import { IsiComponentEvent } from "./IsiComponentEvent";

export class IsiComponentAjaxEvent extends IsiComponentEvent {
    IsiHTTPMethod: "GET" | "POST";
    IsiUrl: string;
    IsiQueued: boolean;

    constructor(name: string, httpMethod: "GET" | "POST", url: string, queued?: boolean) {
        super(name);
        // <summary>
        // Permet de déclarer un évènement AJAX dans le composant (a faire dans le initialize)
        // </summary>
        // <param name="name">Nom de l'évènement.</param>
        // <param name="httpMethod">Méthode HTTP à utiliser (GET,POST).</param>
        // <param name="url">Url.</param>
        // <param name="queued">Indique si l'évènement est inclu dans la file des appels ajax ou bien si il est lancé à n'importe quel moment.</param>
        // <history>
        // LRAT-GBAU - 26/03/2014 : Gestion évènements ajax
        // <history>
        //IsiFW.IsiComponent.initializeBase(this, [name]);
        this.IsiHTTPMethod = httpMethod;
        this.IsiUrl = url;
        this.IsiQueued = queued;
    }

    type() {
        return "AJAX";
    }
}

window.IsiComponentAjaxEvent = IsiComponentAjaxEvent;